<script setup>
import { computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useSectionsStore } from '@/stores/section'
import { useAdsStore } from '@/stores/ads'

import GemiusCode from '@/components/gemius/GemiusCode.vue'
import FooterLayout from '@/components/layout/FooterLayout.vue'
import HeaderLayout from '@/components/layout/HeaderLayout.vue'
import LoaderInfo from '@/components/elements/LoaderInfo.vue'
import { useNavigationStore } from '@/stores/navigation'
import MobileAppLayout from '@/components/layout/MobileAppLayout.vue'
import { useHead } from '@unhead/vue'
import { useSeo } from '@/composables/useSeo'
import { useRoute } from 'vue-router'
import { useAds } from '@/composables/useAds'

const sectionsStore = useSectionsStore()
const { pageSettingType, pageSettings } = storeToRefs(sectionsStore)
const navigationStore = useNavigationStore()
const { loaderPage } = storeToRefs(navigationStore)
const galleryType = computed(() => pageSettingType.value)
const seo = useSeo()
const { seoContent } = seo
const { fetchAndSetMetaSeo } = seo
const route = useRoute()
const query = computed(() => route.query)

useAds()

const adsStore = useAdsStore()
const { fetchAds } = adsStore
const showTopSlot = computed(() =>
  window.innerWidth < 992 && pageSettingType.value === 'SG' ? false : true
)

const isSG = computed(() => pageSettingType.value === 'SG')

const isIframe = computed(() => pageSettingType.value.includes('IFRAME'))
const pageId = computed(() => pageSettings.value?.id)

useHead(seoContent)

watch(
  () => route.path,
  () => {
    if (route.path.includes('program-tv')) {
      fetchAndSetMetaSeo({
        program_id: route.params.id,
        occurrence_id: route.query.o
      })
    } else {
      fetchAndSetMetaSeo({
        id: pageSettings.value.id,
        ...query.value
      })
    }
    fetchAds(pageSettings.value.id)
  },
  { immediate: true }
)
</script>

<template>
  <template v-if="!isIframe">
    <mobile-app-layout />
    <HeaderLayout v-if="galleryType != 'IMAGE_GALLERY'" />
    <section id="wallpaper" class="wallpaper screening"></section>
    <div v-if="showTopSlot" class="top_wrapper ad_slot">
      <div id="top" class="ad_wrapper top"></div>
    </div>
  </template>

  <div class="content-info" id="content-tvp-info">
    <gemius-code :object-id="pageId" />
    <loader-info height="600px" v-if="loaderPage" />
    <section
      id="screening__wrap"
      class="screening__wrapper"
      :style="isSG ? 'position: unset;' : ''"
    >
      <RouterView />
    </section>
  </div>

  <template v-if="!isIframe">
    <FooterLayout v-if="galleryType != 'IMAGE_GALLERY'" />
  </template>
</template>

<style lang="scss">
.content-info {
  position: relative;
  min-height: 100vh;
}
</style>
